/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { WorkAmountResource } from './';
import {
    WorkAmountResourceFromJSON,
    WorkAmountResourceFromJSONTyped,
    WorkAmountResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FillActivityReportRequest
 */
export interface FillActivityReportRequest {
    /**
     * To update detailed activity report only Map of work amounts, key is the day of month and value is the decimal representing how long the freelancer worked on that day
     * @type {{ [key: string]: WorkAmountResource; }}
     * @memberof FillActivityReportRequest
     */
    workAmountsByDays?: { [key: string]: WorkAmountResource; };
    /**
     * To update simple activity report only Total of work amount in the month
     * @type {number}
     * @memberof FillActivityReportRequest
     */
    totalWorkAmount?: number;
    /**
     * Free text informed by the freelancer to explain the work did for that activity report
     * @type {string}
     * @memberof FillActivityReportRequest
     */
    workDescription?: string;
}

/**
 * Check if a given object implements the FillActivityReportRequest interface.
 */
export function instanceOfFillActivityReportRequest(value: object): value is FillActivityReportRequest {
    return true;
}

export function FillActivityReportRequestFromJSON(json: any): FillActivityReportRequest {
    return FillActivityReportRequestFromJSONTyped(json, false);
}

export function FillActivityReportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FillActivityReportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'workAmountsByDays': json['workAmountsByDays'] == null ? undefined : (mapValues(json['workAmountsByDays'], WorkAmountResourceFromJSON)),
        'totalWorkAmount': json['totalWorkAmount'] == null ? undefined : json['totalWorkAmount'],
        'workDescription': json['workDescription'] == null ? undefined : json['workDescription'],
    };
}

export function FillActivityReportRequestToJSON(value?: FillActivityReportRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workAmountsByDays': value['workAmountsByDays'] == null ? undefined : (mapValues(value['workAmountsByDays'], WorkAmountResourceToJSON)),
        'totalWorkAmount': value['totalWorkAmount'],
        'workDescription': value['workDescription'],
    };
}

